import i18next from 'i18next';

import { exportFile } from 'common/api/companies';

import {
    DOWNLOAD_CSV,
    DOWNLOAD_CSV_FAILURE,
    DOWNLOAD_CSV_SUCCESS,
} from '../actionTypes';
import { companiesActions } from '../reducer';

export default (filterData) => (dispatch) => {
    dispatch(companiesActions[DOWNLOAD_CSV]());
    const { countryName, planName, searchText } = filterData;

    exportFile({
        countryName: countryName,
        planName: planName,
        searchText,
    })
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute(
                'download',
                `${i18next.t('Company', { count: 2 })}.csv`,
            );
            document.body.appendChild(link);
            link.click();
            dispatch(companiesActions[DOWNLOAD_CSV_SUCCESS]());
        })
        .catch((error) =>
            dispatch(
                companiesActions[DOWNLOAD_CSV_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
